import { Typography } from '@gds/Typography/Typography';

import { RegionAreaAtom, RegionAtom } from '@search/Atoms/RegionAtom.entity';

export const DealerLocationHeader = ({
  strs,
  region,
  area,
}: {
  strs: Record<string, string>;
  region: RegionAtom;
  area: RegionAreaAtom;
}) => {
  const dealersHeader =
    region.region === 'anyregion'
      ? strs.onHeycar
      : area.region !== 'anyarea'
      ? `${strs.inArea} ${area.displayName}`
      : `${strs.inRegion} ${region.displayName}`;

  return (
    <Typography variant="h2" Component="h1">
      {strs.heading} {dealersHeader}
    </Typography>
  );
};
